module.exports = __webpack_public_path__ + "static/media/B-MobileApp.be7d9977.png";